import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../assets/styles/local/AddProduct.css";
import { SketchPicker } from "react-color";
import { addColorCode, deleteColor } from "../../redux/actions/action";
import plusDottedIcon from "../../assets/icons/plus-dotted-icon.svg";
import deleteIcon from "../../assets/icons/Bin.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const ColorPickers = ({ handleChange, colors }) => {
  const dispatch = useDispatch();
  const [selectedColor, setSelectedColor] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);
  const recentColors = useSelector((state) => state.user.recentColors);
  const handleColorChange = (color) => {
    setSelectedColor(color.hex);
  };
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Add Products and Parts").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const handleAddColor = () => {
    if (selectedColor) {
      dispatch(addColorCode(selectedColor));
      const event = {
        target: {
          name: "productpartvariation",
          value: [
            ...colors,
            {
              colorcode: selectedColor,
              productpartvariationid: new Date().toISOString(),
            },
          ],
        },
      };

      handleChange(event);
    }
    setShowPicker(false);
    setSelectedColor("");
  };

  const handleDeleteColor = (index) => {
    dispatch(deleteColor(index));

    const updatedColorsList = colors.filter(
      (color) => color.productpartvariationid !== index,
    );
    const event = {
      target: {
        name: "productpartvariation",
        value: updatedColorsList,
      },
    };
    handleChange(event);
  };

  const handleClickOutside = (event) => {
    if (pickerRef.current && !pickerRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const selectedColorCircles = colors.map((item, index) => (
    <div key={index}>
      <div
        onClick={() => handleDeleteColor(item.productpartvariationid)}
        className="products-and-parts-color-picker-color products-and-parts-plus-dotted-icon-centered color-list "
        style={{
          backgroundColor: item.colorcode,
          left: `calc(20px * ${index + 1})`,
          top: "70%",
        }}
      ></div>
      <img
        alt=""
        src={deleteIcon}
        className="bin-icon"
        style={{
          left: `calc(20px * ${index + 1})`,
        }}
      />
    </div>
  ));

  return (
    <div
      ref={pickerRef}
      className="d-flex justify-content-center align-content-center"
    >
      <div>
        {selectedColorCircles}
        {colors.length < 1 && (
          <img
            src={plusDottedIcon}
            alt="Plus Icon"
            className="products-and-parts-plus-dotted-icon-general"
            onClick={() => setShowPicker(true)}
            style={{ left: `calc(${colors.length + 1} * 20px)`, top: "70%" }}
          />
        )}
        <input
          type="text"
          className="products-and-parts-tab-colors-input ps-4 cursor-pointer"
          name="color"
          style={{ width: "220px" }}
          onFocus={() => {
            if (colors.length < 1) {
              setShowPicker(true);
            }
          }}
          readOnly
        />
        <div className="d-flex flex-column align-items-center justify-content-center stock-color-picker">
          {showPicker && (
            <SketchPicker
              presetColors={recentColors}
              color={selectedColor}
              onChange={handleColorChange}
            />
          )}
          {selectedColor && (
            <button
              onClick={handleAddColor}
              style={{
                padding: "10px 20px",
                backgroundColor: "#00246A",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              {/* Add */}
              {t("Add")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ColorPickers;
